module.exports = __webpack_public_path__ + "static/media/tl3.3e4e056e.webp";